export default [
  {
    path: "/user/analytic",
    name: "UserDomain",
    component: () => import("@/views/Ondemand/Analytic.vue"),
  },
];